/**
 * Basic dom node selector
 *
 * @param {String|Array|NodeList|HTMLElement} selector what nodes to select
 * @returns {Array[HTMLElement]}
 */
export function select( selector ) {
	let nodes = [];

	if ( Array.isArray( selector ) ) {
		nodes = selector;
	} else if ( selector instanceof NodeList ) {
		nodes = Array.from( selector );
	} else if ( selector instanceof HTMLElement ) {
		nodes = [ selector ];
	} else if ( typeof selector === 'string' ) {
		nodes = Array.from( document.querySelectorAll( selector ) );
	} else {
		console.error( "Invalid node selector", selector );
	}

	nodes = nodes.filter( node => node instanceof HTMLElement );

	return nodes;
}

/**
 * Observe an elements scroll position and resolve a promise after it's passed it's threshold visibility
 *
 * @param {HTMLElement} node the element to observe it's scroll position
 * @param {Object} opts
 * @returns {Promise}
 */
export function observe( node, opts = { threshold: 50 } ) {
	return new Promise(( resolve, reject ) => {
		let threshold = parseFloat( opts.threshold );

		if ( isNaN( threshold ) ) {
			threshold = 50;
		}

		threshold = Math.min( 100, Math.max( 0, threshold ) ) / 100;

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach( entry => {
					if ( entry.isIntersecting ) {
						resolve( entry );
						observer.disconnect();
					}
				});
			},
			{
				threshold,
			}
		);

		observer.observe( node );
	});
}

/**
 * Normalize a duration variable that defaults to ms without a time unit
 *
 * @param {Number|String} duration
 * @returns {String}
 */
export function parseDuration( duration ) {
	if ( Number.isInteger( duration ) || ! isNaN( parseFloat( duration ) ) ) {
		return `${duration}ms`;
	}

	return duration;
}

